import { Box, Typography, Chip, Stack } from "@mui/material";
import { formatDate, truncateName } from "components/common/Utils/commonUtilityFunctions";
import { BoardView } from "../types/boardView";
import { WorkOrder } from "../models/workOrderTypes";
import { dateRowWrapperBox } from "../models/workOrderStyles";
import { useWorkOrderStatusColors } from "../shared/useWorkOrderStatusColors";

const WorkOrderCardDateDaysStatusRow = ({
  workOrderObj,
  boardView,
  onToggleExpand,
}: {
  workOrderObj: WorkOrder;
  boardView?: BoardView;
  onToggleExpand: () => void;
}) => {
  const showStatusChip = boardView === BoardView.Technician;
  const { borderColor, chipSx } = useWorkOrderStatusColors(workOrderObj);

  const statusLabel =
    truncateName(workOrderObj.status, 25) +
    (workOrderObj.daysInCurrentstatus > 0
      ? ` ${workOrderObj.daysInCurrentstatus}d ago`
      : "");

  if (showStatusChip) {
    return (
      <Stack
        direction="row"
        onClick={onToggleExpand}
        sx={{
          borderLeft: `4px solid ${borderColor}`,
          borderBottomLeftRadius: "4px",
          flex: 1,
          width: "100%",
          cursor: "pointer",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
          },
        }}
        display="flex"
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          width="100%"
          m="5px"
          ml="15px"
        >
          <Box flex={1}>
            <Typography
              sx={{
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "12px",
              }}
              variant="subtitle2"
            >
              <b>{formatDate(workOrderObj.createdDate)}</b>
            </Typography>
          </Box>

          <Box flex={1} display="flex" justifyContent="flex-end">
            <Chip label={statusLabel} size="small" sx={chipSx} />
          </Box>
        </Box>
      </Stack>
    );
  }

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      ml="10px"
      onClick={onToggleExpand}
      sx={{
        cursor: "pointer",
        "&:hover": {
          backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
      }}
    >
      <Box sx={{ ...dateRowWrapperBox, m: 1 }}>
        <Typography
          sx={{
            fontStyle: "normal",
            fontWeight: "500",
            fontSize: "12px",
          }}
          ml={1}
          variant="subtitle2"
        >
          <b>{formatDate(workOrderObj.createdDate)}</b>
        </Typography>
      </Box>
    </Box>
  );
};

export default WorkOrderCardDateDaysStatusRow;
